module.exports = __webpack_public_path__ + "img/stock2.aa7cdb6b.png";